import { storage } from "../../fb"
import imageCompression from 'browser-image-compression';

// pictures: LIST of pictures - either of objects or strings
// setProgress is a state function - [progress, setProgress] = useState()
// docRef is the ID of the document the images belong to
// taskFunction is the function to be passed, either an edit or a create function
// task is a string, should either be "edit" or "create"
// directory is a string that contains the save directory e.g "portfolio/${category}/${docRef}" -
// directory should have no "/" before and after the string. See example above
const handleUpload = async ({ pictures, setProgress, docRef, taskFunction, task, directory }) => {
    let uploaded = 0
    let urls = []
    let files = []
    urls = pictures.filter((file) => typeof (file) === "string")
    files = pictures.filter((file) => typeof (file) === "object")
    // If files list is empty, that means no image file has been added,
    // meaning that all elements of pictures list are URLs, 
    // so no need to upload
    if (files.length === 0 && task === "edit") {
        taskFunction({ urls })
        return
    }
    // Compress image files
    const compress = async () => {
        files = await Promise.all(
            files.map(
                async (file) => {
                    return await imageCompression(file.file, { maxSizeMB: 0.6 })
                }
            )
        )
    }
    await compress()

    // Upload function + get URL/s
    files.forEach((picture) => {
        const storageRef = `${directory}/${picture.name}${picture.lastModified}`
        const uploadTask = storage.ref(storageRef).put(picture)
        uploadTask.on(
            "state_changed",
            snapshot => {
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                )
                if (progress === 100) {
                    uploaded += 100 / pictures.length
                    setProgress(uploaded)
                }
            },
            error => {
                console.log(error)
            },
            async () => {
                await storage
                    .ref(storageRef)
                    .getDownloadURL()
                    .then(url => {
                        urls.push(url)
                        if (urls.length === pictures.length) {
                            // do the function, edit || create
                            taskFunction({ urls, docRef })
                        }
                    })
            })
    })
}

export { handleUpload }